import { memo } from 'react';

import BreadcrumbLinkWithDropdown from '@/components/atomic/templates/navigation/breadcrumbs/components/breadcrumb/link/with-dropdown';
import BreadcrumbLinkWithoutDropdown from '@/components/atomic/templates/navigation/breadcrumbs/components/breadcrumb/link/without-dropdown';
import withExposer from '@/hocs/with-exposer';
import { BasicComponentProps } from '@/typings/generic';

interface BreadcrumbLinkProps extends BasicComponentProps {
	title?: string;
	toggleDropdown?: () => void;
	dropdownOpen?: boolean;
	hasDropdown?: boolean;
	index: number;
}

const BreadcrumbLinkComponent: React.FC<BreadcrumbLinkProps> = ({
	$exposerSuffix,
	title,
	dropdownOpen,
	toggleDropdown,
	hasDropdown,
	index,
}) => {
	if (!title) return null;

	if (!hasDropdown) {
		return (
			<BreadcrumbLinkWithoutDropdown
				$exposerSuffix={$exposerSuffix}
				title={title}
			/>
		);
	}

	return (
		<BreadcrumbLinkWithDropdown
			$exposerSuffix={$exposerSuffix}
			title={title}
			dropdownOpen={dropdownOpen}
			toggleDropdown={toggleDropdown}
			index={index}
		/>
	);
};

const BreadcrumbLink = memo(
	withExposer(BreadcrumbLinkComponent, 'breadcrumb_link'),
);

export default BreadcrumbLink;
